import template_report from './sx/router'

export default [{
    path: 'template',
    name: 'template',
    component: r => require.ensure([], () => r(require('./index.vue')), 'template'),
    children: [
        template_report,
    ]
}]
